import { createSlice } from '@reduxjs/toolkit'

export const userDetailSlice = createSlice({
  name: 'userDetail',
  initialState: {
    isLoggedIn: false,
    oktaUser: null,
    appUser: null,
    makeProgramApiCall: false,
    cookieContent: true,
  },
  reducers: {
    setOktaUser: (state, action) => {
      state.oktaUser = action.payload
    },
    setAppUser: (state, action) => {
      state.appUser = action.payload
    },
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload
    },
    setFetchProgramApicall: (state, action) => {
      state.makeProgramApiCall = action.payload
    },
    setCookieContent: (state, action) => {
      state.cookieContent = action.payload
    },
  },
})

export const { setOktaUser, setAppUser, setIsLoggedIn, setFetchProgramApicall, setCookieContent } = userDetailSlice.actions

export default userDetailSlice.reducer
